import React, { useState } from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";
import Button from "../../../components/button";

import "./downloadsPieceInfoGroup.css";
import ButtonWithSpeechBubble, { ButtonWithSpeechBubbleSpeechBubbleProps } from "../../../components/buttonWithSpeechBubble";
import { PieceControllerApi, PieceResponseDTO } from "../../../openapi-generated-client";
import { getApiUrl } from "../../../data/api/apiManager";

interface DownlaodsPieceInfoGroupProps {
    piece: PieceResponseDTO;
    canDownload: boolean;
    sessionId?: string;
}

export default function DownloadsPieceInfoGroup(props: DownlaodsPieceInfoGroupProps) {

    const [downloading, setDownloading] = useState(-1);

    if(props.piece.scores.length == 0) return <></>;

    return <>
        <h4>Downloads</h4>
        <ul className="download-list small">
            {props.piece.scores.map((score, index) => (
                <li key={index}>
                    <a>{score.name}</a>
                    <ButtonWithSpeechBubble loading={downloading === index} disabled={!props.canDownload} onClick={() => {
                        if(props.canDownload) {
                            downloadScore(props.piece.id, index, score.name!, (v: boolean) => {
                                setDownloading(v ? index : -1);
                            }, props.sessionId);
                        }
                    }} bubbleText="You need to first buy this piece">Download</ButtonWithSpeechBubble>
                </li>
            ))}
        </ul>
    </>;
}

export async function downloadScore(pieceId: number, score: number, scoreName: string, setDownloadLoading: (v: boolean) => void, sessionId?: string) {
        setDownloadLoading(true);
        const response = await fetch(getApiUrl("piece/" + pieceId + "/download/" + score), {
            method: "GET",
            headers: {
                authorization: sessionId || "",
            }
        });
        const data = await response.blob();
        var file = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = file;
        a.download = scoreName + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setDownloadLoading(false);
    }